import styled from "styled-components";

export const MainComponent = styled.div`
    background: var(--backgroundBlue);
    border-radius: 3rem;
    padding: 3rem;
    margin:2rem;
    margin-bottom: 3rem;
    @media (max-width: 769px) {
        margin: 0.5rem;
        margin-bottom: 3rem;
        padding: 0.5rem;
    }
    
`;

export const CityName = styled.h1`
    display: flex;
    color: var(--thirdBlue);
    justify-content: space-evenly;
    font-size: 4rem;
    @media (max-width: 769px) {
        font-size: 2rem;
    }
`;

export const CardGroup = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 3rem 2rem;
    @media (max-width: 769px) {
        flex-wrap: wrap;
        justify-content: space-around;
    }
`;

export const GraphicGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    object-fit: cover;
    justify-content: space-around;
    @media (max-width: 769px) {
        min-width: 350px;
    }
    @media (max-width: 1080px) {
        min-width: 350px;

    }
`;

export const LineChart = styled.div`
    max-width:100%;
    margin:0.5rem;
    padding:0.7rem;
    @media (max-width: 769px) {
        min-width: 350px;
    }
    @media (max-width: 1080px) {
        max-width: 900px;

    }
`;

export const BarChartStyle = styled.div`
    max-width:100%;
    margin:0.5rem;
    padding:0.7rem;
    @media (max-width: 769px) {
        min-width: 350px;
    }
    @media (max-width: 1080px) {
        max-width: 900px;
    }
`;